export const getBlocksDataFromSectionData = ({
  blocks = {},
  blocksOrder = [],
}: {
  blocks?: {
    [key: string]: Customisation.Block
  }
  blocksOrder?: string[]
}) => blocksOrder.map((blockId) => blocks[blockId])
